import { type FC } from 'react';
import cn from 'classnames';
import { Skeleton } from '@/components/Skeletons/Skeleton/Skeleton';
import styles from './callOrdersTableSkeleton.module.scss';

interface ICallOrdersTableSkeletonProps {
  /** Сколько строк-заглушек рисовать. */
  rows?: number;
  /** Учитывать колонку «Клиент» — сетка на одну колонку шире. */
  withClient?: boolean;
}

/** Колонок столько же, сколько в таблице заказов («Суммы» нет с PAR-5189). */
const COLUMNS = 4;
const COLUMNS_WITH_CLIENT = 5;
const DEFAULT_ROWS = 10;

/**
 * Заглушка таблицы заказов на время загрузки. Повторяет сетку реальной
 * таблицы, чтобы после подстановки данных раскладка не прыгала.
 */
export const CallOrdersTableSkeleton: FC<ICallOrdersTableSkeletonProps> = ({
  rows = DEFAULT_ROWS,
  withClient = false
}) => {
  const columns = withClient ? COLUMNS_WITH_CLIENT : COLUMNS;

  return (
    <div
      className={cn(styles['call-orders-skeleton'], {
        [styles['call-orders-skeleton_wide']]: withClient
      })}
      aria-hidden="true"
    >
      <div
        className={cn(
          styles['call-orders-skeleton__row'],
          styles['call-orders-skeleton__row_head']
        )}
      >
        {Array.from({ length: columns }, (_, index) => (
          <Skeleton key={index} variant="text" height="12px" />
        ))}
      </div>

      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className={styles['call-orders-skeleton__row']}>
          {Array.from({ length: columns }, (_, index) => (
            <Skeleton key={index} variant="text" height="14px" />
          ))}
        </div>
      ))}
    </div>
  );
};
